<template>

</template>

<script>
    const PROFILES_API = '/api/profiles'
    const APPCONFIG_API = '/api/appConfig'
    import BaseComponent from '../scenarios/BaseComponent'

    export default {
        name: 'VisCommon',
        extends: BaseComponent,
        created: function () {
            this.checkToken()
            this.loadState()
            this.loadAppConfig()
        },
        data () {
            return {
                confirmation: true,
                appconfig: {},
                isActive: false
            }
        },
        methods: {
            loadAppConfig() {
                let that = this
                this.$http.get(APPCONFIG_API, {headers: this.prepareSecurityHeader()})
                    .then((response) => {
                        that.appconfig = response.data
                    })
                    .catch((error) => {
                        console.log(error)
                        that.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ')
                    })
            },
            loadState() {
                let that = this
                this.$http({
                    url: PROFILES_API + '/activeState/' + this.loggedId,
                    headers: this.prepareSecurityHeader()
                }).then((response) => {
                    that.isActive = response.data
                    if (!that.isActive) {
                        openMessage({
                            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
                            type: 'danger',
                            showCloseButton: true
                        })
                    }
                }).catch((error) => {
                    console.log(error)
                    that.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].scenarios.errorToGetUserStatus)
                })
            },
            getDateFormat(datetime) {
              let now = new Date(datetime)
              let dd = now.getDate()
              let mm = now.getMonth() + 1 // January is 0!
              let hh = now.getHours()
              let min = now.getMinutes()
              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              if (hh < 10) {
                hh = '0' + hh
              }
              if (min < 10) {
                min = '0' + min
              }
              return dd + '.' + mm + '.' + now.getFullYear() + ' ' + hh + ':' + min
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VisCommon.vue?70a12d6f